import React from "react";
import "./OrganisationTabbar.css";
import { Col, Container, Row, Tab, Tabs } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import ApplicationsTab from "./applicationsTab/ApplicationsTab";
import DepartmentsTab from "./departmentsTab/DepartmentsTab";

class OrganisationTabbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = { departments: [] };
  }

  handleDepartmentsFetched = (data) => {
    this.setState({ departments: data });
  };

  render() {
    const { t } = this.props;
    return (
      <Container className="mt-3">
        {this.state.apiError ? (
          <Row>
            <Col>{this.state.apiError}</Col>
          </Row>
        ) : (
          ""
        )}

        <Row>
          <Col className="p-0">
            <Tabs defaultActiveKey="system">
              <Tab
                eventKey="system"
                tabClassName="item-link"
                title={t("Organisation.OrganisationTabbar.DepartmentsTitle")}
              >
                <DepartmentsTab
                  departmentCallback={this.handleDepartmentsFetched}
                />
              </Tab>
              <Tab
                eventKey="sentinel"
                tabClassName="item-link"
                title={t("Organisation.OrganisationTabbar.ApplicationsTitle")}
              >
                <ApplicationsTab departments={this.state.departments} />
              </Tab>
            </Tabs>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default withTranslation()(OrganisationTabbar);
